import React from 'react';
import LegalPage from './home/LegalPage';

const PrivacyBeleid = () => <LegalPage page="privacy" path="/privacy-beleid" testId="privacy-page" />;

export default PrivacyBeleid;
